import { useEffect, useState, useCallback } from "react"
import { isClient } from "../utils/isClient"

export default function() {
  const getWindowSize = useCallback(() => {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0,
    }
  }, [isClient])

  const [windowSize, setWindowSize] = useState(getWindowSize)

  useEffect(() => {
    if (!isClient) {
      return false
    }

    function resize() {
      setWindowSize(getWindowSize())
    }

    if (isClient) {
      window.addEventListener("resize", resize)
    }

    return () =>
      isClient ? window.removeEventListener("resize", resize) : null
  }, [isClient, getWindowSize])

  return windowSize
}
